<as-split   direction="horizontal" [gutterSize]="gutterSize" (dragEnd)="notifySplitviewMoved($event)" (dragStart)="notifySplitviewMoving(true)">
  <as-split-area [size]="listSize" >
    <ng-content #listComponent select=".split-view-content-list"></ng-content>
  </as-split-area>
  <as-split-area [size]="detailSize" class="docside">
    @if (busy) {
      <div class="overlay"></div>
    }
    <ng-content #detailComponent select=".split-view-content-detail"></ng-content>

  </as-split-area>
</as-split>
